var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('i',{class:_vm.icon}),_c('ul',_vm._l((_vm.links),function(link){return _c('li',[_c('a',{attrs:{"href":link.href}},[_vm._v(_vm._s(link.name))])])}))])}
var staticRenderFns = []

export { render, staticRenderFns }